// Who made a packing-plan edit (jobq-api plan_manual_edits.edited_by).
//
// Until 2026-10-26 the SO page's Edit-plan calls sent no name, so half the audit rows read
// "nobody". The SO page is admin-gated, so the admin session's name is who is editing (the
// same rule as earmarks and beacons: utils/beacons.currentActor, repeated here because that
// module loads config.js / axios). Every plan-edit request goes through one of these two.
//
// Since 2026-10-27 (Shipping hub, Phase 1) the "Working as" session's name comes first: the person signed in at
// the screen is who is editing, and an admin session left open on a shop PC stops being recorded as them.
import { liveSession } from '../operatorSession/session';

export function planEditor() {
  const s = liveSession();
  if (s && s.name && s.name.trim()) return s.name.trim();
  try {
    const n = sessionStorage.getItem('userName');
    return n && n.trim() ? n.trim() : null;
  } catch (_) {
    return null;
  }
}

/** The JSON body with `edited_by` filled in (a name the caller already set is kept). */
export function withEditor(body) {
  const out = { ...(body || {}) };
  if (!out.edited_by) out.edited_by = planEditor();
  return out;
}

/** A DELETE path whose API reads the editor from the query string. */
export function withEditorQuery(path) {
  const name = planEditor();
  if (!name) return path;
  return `${path}${path.includes('?') ? '&' : '?'}edited_by=${encodeURIComponent(name)}`;
}
